module.exports = __webpack_public_path__ + "static/media/liviu_atudorei.195c2511.png";